import * as THREE from 'three';
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { latLongToVector3 } from '../../utils/earth';
import { CUSTOM_EVENT } from '../../config';

export default class {
    constructor(data, camera, visibilityMesh) {         
        this.data = data;

        // Create HTML
        const $el = document.createElement( 'div' );
        $el.classList.add('c-explore_label-wrapper')
        $el.classList.add('is-hidden');
        const $inner = document.createElement('div');
        $inner.classList.add('c-explore_label')
        $el.append($inner);
        if(data.items) {
            const $content = document.createElement('div');
            $inner.append($content);
            $content.classList.add('c-explore_cluster')            
            for(let item of data.items) {
                const $clusterItem = document.createElement('a');
                $clusterItem.href = item.url;
                $clusterItem.dataset.id = item.id;
                $clusterItem.classList.add('c-explore_pin')
                $clusterItem.classList.add('c-explore_cluster-item')
                $clusterItem.title = item.title
                $clusterItem.tabIndex = -1;
                $clusterItem.setAttribute('draggable', false)
                $content.append($clusterItem);
            }
        } else {                
            const $content = document.createElement('a');
            $inner.append($content);
            $content.classList.add('c-explore_pin');
            $content.classList.add('-single');
            $content.href = data.url;
            $content.dataset.id = data.id;
            $content.title = data.title
            $content.tabIndex = -1;
            $content.setAttribute('draggable', false)
        }

        this.arriving = true;
        requestAnimationFrame(() => {
            this.arriving = false;
        })

        this.object = new CSS2DObject( $el );
        this.object.userData = {
            cNormal: new THREE.Vector3(),
            cPosition: new THREE.Vector3(),
            mat4: new THREE.Matrix4(),
            trackVisibility: () => { // the closer to the edge, the less opacity
                if(this.removing || this.arriving) return;

                let ud = this.object.userData;
                ud.cNormal.copy(this.object.position).normalize().applyMatrix3(visibilityMesh.normalMatrix);
                ud.cPosition.copy(this.object.position).applyMatrix4(ud.mat4.multiplyMatrices(camera.matrixWorldInverse, visibilityMesh.matrixWorld));
                let d = ud.cPosition.negate().normalize().dot(ud.cNormal); 
                // object.element.innerText = d;
                this.object.element.classList.toggle('is-hidden', d < 0)

                // d = smoothstep(0.2, 0.7, d);
                // object.element.style.opacity = d;                    
                
                // https://github.com/gre/smoothstep/blob/master/index.js
                // function smoothstep (min, max, value) {
                // var x = Math.max(0, Math.min(1, (value-min)/(max-min)));
                // return x*x*(3 - 2*x);
                // };
            }
        }
        this.object.position.copy(latLongToVector3(data.lat, data.lng, 1));

        this.bindEvents();
    }

    bindEvents() {
        this.onMouseEnter = this.onMouseEnter.bind(this)
        this.onMouseLeave = this.onMouseLeave.bind(this)

        for(let item of this.object.element.querySelectorAll('[data-id]')) {
            item.addEventListener('mouseenter', this.onMouseEnter);
            item.addEventListener('mouseleave', this.onMouseLeave);    
        }
    }

    unbindEvents() {
        for(let item of this.object.element.querySelectorAll('[data-id]')) {
            item.removeEventListener('mouseenter', this.onMouseEnter);
            item.removeEventListener('mouseleave', this.onMouseLeave);    
        }        
    }

    onMouseEnter(e) {
        const {target} = e;
        const id = target.dataset.id;

        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.EXPLORE_PIN_ENTER, {
            detail: {
                id
            }
        }))
    }

    onMouseLeave(e) {
        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.EXPLORE_PIN_LEAVE))
    }

    setActive(value, id) {
        this.object.element.classList.toggle('is-active', value);
        
        const cluster = this.object.element.querySelector('.c-explore_cluster')
        cluster?.classList.remove('is-active')
        for(let item of this.object.element.querySelectorAll('[data-id]')) {
            item.classList.remove('is-active')
        }
        if(value && id) {
            const item = this.object.element.querySelector('[data-id="'+id+'"]')
            if(item) {
                item.classList.add('is-active')
                cluster?.classList.add('is-active')
            }
        }
    }

    update() {
        this.object?.userData.trackVisibility();
    }

    remove() {
        this.removing = true;

        this.unbindEvents();
        
        return new Promise(resolve => {
            this.object.element.classList.add('is-hidden');
            setTimeout(resolve, 300);
        }) 
    }
}